
import { Options, Vue, prop } from "vue-class-component";
import ModalV2 from "@/app/ui/components/modal-v2/index.vue";
import LpButton from "@/app/ui/components/lp-button/index.vue";
import { FlagsPermissionHorde } from "@/feature-flags";
import openLabelPdfWithAuth from "@/app/ui/views/pickup/common/openLabelPdfWithAuth";

class Props {
  visible = prop<boolean>({
    default: false,
    type: Boolean
  });
  orderId = prop<string>({
    default: "",
    type: String
  });
  totalKoli = prop<number>({
    default: 0,
    type: Number
  });
  totalWeightKg = prop<number>({
    default: 0,
    type: Number
  });
  pickupDate = prop<string>({
    default: "",
    type: String
  });
  pickupTimeStart = prop<string>({
    default: "",
    type: String
  });
  labelUrl = prop<string>({
    default: "",
    type: String
  });
}

@Options({
  emits: ["close", "view-detail"],
  components: {
    ModalV2,
    LpButton
  },
  watch: {
    visible(val: boolean) {
      if (val && this.isDhlWhitelist && this.labelUrl) {
        this.$nextTick(() => {
          openLabelPdfWithAuth(this.labelUrl).catch(() => undefined);
        });
      }
    }
  }
})
export default class ModalPickupRequestSuccess extends Vue.with(Props) {
  get formattedPickupDate(): string {
    if (!this.pickupDate) return "";
    const months = [
      "Januari",
      "Februari",
      "Maret",
      "April",
      "Mei",
      "Juni",
      "Juli",
      "Agustus",
      "September",
      "Oktober",
      "November",
      "Desember"
    ];
    const date = new Date(this.pickupDate);
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  }

  get formattedPickupTime(): string {
    if (!this.pickupTimeStart) return "";
    const [h, m] = this.pickupTimeStart.split(":");
    const start = `${h}.${m}`;
    const endH = String(Number(h) + 1).padStart(2, "0");
    const end = `${endH}.${m}`;
    return `${start} - ${end}`;
  }

  get formattedTotalRequest(): string {
    return this.$t("pickup.requestSuccess.summary.totalValue", {
      totalKoli: this.totalKoli,
      totalWeightKg: this.totalWeightKg
    }) as string;
  }

  get isDhlWhitelist(): boolean {
    return FlagsPermissionHorde.dhl_first_mile_client_whitelist.isEnabled();
  }

  onClose(): void {
    this.$emit("close");
  }

  goToDetail(): void {
    this.$router.push(`/pickup/list-pickup-v2/${this.orderId}`);
    this.$emit("close");
  }
}
